<template>
  <div>
    <v-row align="center" style="margin: 20px 20px 0">
      <v-col class="d-flex" cols="12" sm="5">
        <b style="margin-top: 6px">
          {{ excelName }}
        </b>
        <v-btn
          color="primary white--text"
          rounded
          class="filterMarginButton"
          @click="showSelectMealDialog = true"
        >
          تغییر وعده
        </v-btn>
      </v-col>

      <v-col class="d-flex" cols="12" sm="4">
        <v-switch
          v-model="tempAutoDelivery"
          @change="setAutoDelivery"
          label=":تحویل خودکار"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="3">
        <export-excel
          style="float: left"
          worksheet="My Worksheet"
          :name="excelName"
          :data="excelData"
          :fields="excelHeaders"
        >
          <app-history title="خروجی اکسل" />
        </export-excel>
      </v-col>
    </v-row>
    <date-picker
      ref="datepicker1"
      v-model="tempSelectedDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <template v-if="menuItems.length > 0">
      <v-row align="center" style="margin: 0 20px">
        <v-col class="d-flex" cols="4" md="2">
          <b>انتخاب فرد:</b>
        </v-col>
        <v-col class="d-flex" cols="6" md="2">
          <v-text-field
            v-model="searchInput"
            ref="code"
            @keydown.enter="fromBarcode"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="1" md="1" v-if="currentFard">
          <!-- <v-btn
            color="red white--text"
            rounded
            class="filterMarginButton"
            @click="ClearCode"
          >
            پاک کردن
          </v-btn> -->
          <font-awesome-icon
            icon="times"
            size="2x"
            @click="ClearCode"
            color="red"
            style="cursor: pointer;"
          />
        </v-col>
        <v-col class="d-flex fardName" cols="4" md="1"> </v-col>
        <v-col class="d-flex fardName" cols="4" md="6">
          {{ currentFard }}
        </v-col>
      </v-row>
      <!-- <v-row
        v-if="showManualReserveButton && currentFard"
        align="center"
        style="margin: 0 20px"
      >
        <v-col class="d-flex" cols="12">
          <span style="margin-top: 6px">کاربر این وعده را رزرو نکرده است.</span>
          
        </v-col>
      </v-row> -->
      <template v-if="!isMobile">
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-right" style="width: 15%"></th>
              <th class="text-right" style="width: 20%"></th>
              <th
                v-for="item in menuItems"
                :key="item.id"
                class="text-center"
                style="line-height: 2; font-size: 16px"
              >
                کل: {{ item.totalOrders }}
                <br />
                تحویل: {{ item.totalDelivered }}
                <br />
                مانده:
                {{ item.totalNoTahvil }}
                <br style="margin-bottom: 10px" />
                <v-btn
                  color="red white--text"
                  rounded
                  style="margin-bottom: 10px"
                  @click="cancelMenu(item.id, item.food.name)"
                >
                  لغو وعده
                </v-btn>
              </th>
              <th class="text-center" style="width: 15%">
                <v-btn
                  color="secondary white--text"
                  rounded
                  class="filterMarginButton"
                  @click="GetDeliveryPlaceOrders"
                  style="margin-top: 100px;"
                >
                  به روز رسانی
                </v-btn>
              </th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th class="text-right" style="width: 15%">شماره ملی</th>
              <th class="text-right" style="width: 20%">نام</th>
              <th v-for="item in menuItems" :key="item.id" class="text-center">
                {{ item.food.name }}
              </th>
              <th class="text-right" style="width: 15%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="key in Object.keys(filteredOrder)" :key="key">
              <td>{{ key }}</td>
              <td>{{ filteredOrder[key][0].fardName }}</td>
              <td v-for="item in menuItems" :key="item.id" class="text-center">
                {{ findMenuInOrders(item.id, key) }}
              </td>
              <td v-if="filteredOrder[key][0].deliveryDate == null">
                <v-btn
                  color="primary white--text"
                  rounded
                  class="filterButton"
                  @click="deliverOrders(key)"
                >
                  تحویل
                </v-btn>
              </td>
              <td v-else>{{ "تحویل داده شده" }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
      <template v-else>
        <div v-for="item in menuItems" :key="item.id" style="padding: 5px 30px">
          <div class="divider dchild">
            {{ item.food.name }}
          </div>

          <v-row align="center">
            <v-col class="d-flex" cols="3"> کل: {{ item.totalOrders }} </v-col>
            <v-col class="d-flex" cols="3">
              تحویل: {{ item.totalDelivered }}
            </v-col>
            <v-col class="d-flex" cols="3">
              مانده:
              {{ item.totalNoTahvil }}
            </v-col>
            <v-col class="d-flex" cols="3">
              <v-btn
                color="red white--text"
                rounded
                @click="cancelMenu(item.id, item.food.name)"
              >
                لغو وعده
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <v-row class="ltr">
          <v-col>
            <v-btn
              color="secondary white--text"
              rounded
              class="filterMarginButton"
              @click="GetDeliveryPlaceOrders"
              style="margin: 30px 30px 10px;"
            >
              به روز رسانی
            </v-btn>
          </v-col>
        </v-row>
        <hr style="margin: 10px 30px ;" />
        <v-simple-table>
          <!-- <thead>
            <tr>
              <th class="text-right" style="width: 15%">شماره ملی</th>
              <th class="text-right" style="width: 20%">نام</th>
              <th v-for="item in menuItems" :key="item.id" class="text-center">
                {{ item.food.name }}
              </th>
              <th class="text-right" style="width: 15%"></th>
            </tr>
          </thead> -->
          <tbody>
            <tr
              v-for="key in Object.keys(filteredOrder)"
              :key="key"
              class="v-data-table__mobile-table-row"
            >
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ filteredOrder[key][0].fardName }} ({{ key }})
                </div>

                <div class="v-data-table__mobile-row__cell">
                  <v-btn
                    v-if="filteredOrder[key][0].deliveryDate == null"
                    color="primary white--text"
                    rounded
                    class="filterButton"
                    @click="deliverOrders(key)"
                  >
                    تحویل
                  </v-btn>
                  <span v-else> {{ "تحویل داده شده" }}</span>
                </div>
              </td>
              <td
                v-for="item in menuItems"
                :key="item.id"
                class="v-data-table__mobile-row"
              >
                <div class="v-data-table__mobile-row__cell">
                  {{ item.food.name }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  <div class="circle">{{ findMenuInOrders(item.id, key) }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
    </template>
    <template v-else>
      <v-card-text style="margin-right: 20px"
        >هیچ غذایی برای این وعده تعریف نشده است.</v-card-text
      >
    </template>
    <v-dialog v-model="showSelectMealDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          <b>تاریخ:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="tempSelectedDate"
            @click="onClickDate"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> <b>وعده:</b> </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="meals"
            item-text="name"
            item-value="id"
            v-model="tempSelectedMeal"
            return-object
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> <b>مکان تحویل:</b></v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="places"
            item-text="name"
            item-value="id"
            v-model="deliveryPlaceId"
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="GetMealMenus(true)"
        >
          انتخاب
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="showSelectMealDialog = false"
        >
          بستن
        </v-btn>
      </v-row>
    </v-dialog>
    <v-dialog v-model="showManualReserveDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="4" sm="4"> تعرفه </v-col>
        <v-col class="d-flex" cols="8" sm="8">
          <v-select
            :items="kPrices"
            item-text="text"
            item-value="id"
            v-model="selectedMenuPrice"
          ></v-select>
        </v-col>
      </v-row>
      <v-row
        align="center"
        v-for="(menu, index) in menuItems"
        :key="menu.id"
        :style="[index % 2 == 0 ? { 'background-color': 'lightgray' } : '']"
        class="startMenu"
      >
        <v-col class="d-flex" cols="12" sm="4">
          {{ menu.food.name }}
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          قیمت: {{ menu.menuPrices[selectedMenuPrice - 1].price }} ریال
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <app-minusplusfield
            :min="0"
            :max="menu.menuPrices[0].tedadMojazSefaresh"
            :value="menu.numberOfOrders"
            v-model="menu.numberOfOrders"
          ></app-minusplusfield>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="saveAndDeliver"
        >
          رزرو و تحویل
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="showManualReserveDialog = false"
        >
          بستن
        </v-btn>
      </v-row>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="tempAutoDelivery ? 0 : 5000"
      :color="snackbar.success ? 'success' : 'error'"
    >
      <template v-slot:default>
        <span
          v-html="snackbar.text"
          style="  font-size: 30px;  padding: 30px;  display: block;  line-height: 2;"
        >
        </span>
        <v-btn
          color="orange"
          style="float: left "
          variant="text"
          @click="
            {
              snackbar.show = false;
              ClearCode();
            }
          "
        >
          بستن
        </v-btn>
        <v-btn
          v-if="showManualReserveButton"
          color="green white--text"
          style="float: left; margin-left: 10px;"
          @click="showManualReserveDialogAction"
        >
          رزرو دستی
        </v-btn>
      </template>
    </v-snackbar>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import { GetBranchActiveMeals } from "@/api/meals";
import { GetMealMenus, CancelMenu } from "@/api/menus";
import PlusMinusField from "@/components/PlusMinusField";
import { GetDeliveryPlaceOrders, Delivery, SaveAndDeliver } from "@/api/orders";
import { GetBranchDeliveryPlace } from "@/api/deliveryplace";
import { TODAY } from "@/utils/constants";
import moment from "moment-jalaali";
import { FindUserByCode } from "@/api/user";
import { setAutoDelivery } from "@/utils/auth";
import Dialog from "@/components/Dialog";
import HistoryButton from "@/components/HistoryButton";

export default {
  components: {
    appMinusplusfield: PlusMinusField,
    appDialog: Dialog,
    appHistory: HistoryButton,
  },
  data() {
    return {
      places: [],
      deliveryPlaceId: 0,
      meals: [],
      selectedMeal: null,
      tempSelectedMeal: null,
      currentFard: "",
      searchInput: "",
      selectedDate: TODAY,
      tempSelectedDate: TODAY,
      menuItems: [],
      orders: [],
      selectedFardId: 0,
      UserSelected: false,
      BarcodeReaded: false,
      showManualReserveButton: false,
      showSelectMealDialog: false,
      showManualReserveDialog: false,
      tempAutoDelivery: true,
      selectedMenuPrice: 1,
      kPrices: [
        {
          id: 1,
          text: "طلبه",
        },
        {
          id: 2,
          text: "استاد",
        },
        {
          id: 3,
          text: "پرسنل",
        },
        {
          id: 4,
          text: "لیست",
        },
        {
          id: 5,
          text: "سایر",
        },
      ],
      snackbar: {
        show: false,
        text: "",
        success: false,
      },
      tempUser: { id: 0, name: "" },
    };
  },
  computed: {
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    autoDelivery() {
      return this.$store.getters.autoDelivery;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    filteredOrder() {
      if (/\d{10}/.test(this.searchInput)) {
        return Object.keys(this.orders)
          .filter((key) => key.indexOf(this.searchInput) > -1)
          .reduce((cur, key) => {
            cur[key] = this.orders[key];
            return cur;
          }, {});
      } else {
        return Object.keys(this.orders)
          .filter(
            (key) =>
              key.indexOf(this.searchInput) > -1 ||
              this.orders[key][0].fardName.indexOf(this.searchInput) > -1
          )
          .reduce((cur, key) => {
            cur[key] = this.orders[key];
            return cur;
          }, {});
      }
    },
    excelName() {
      return `${this.selectedMeal ? this.selectedMeal.name : ""} روز ${
        this.selectedDate
      }`;
    },
    excelHeaders() {
      var result = {
        "شماره ملی": "nationalCode",
        نام: "fullName",
      };
      for (var item of this.menuItems) {
        result[item.food.name] = "item_" + item.id;
      }
      return result;
    },
    excelData() {
      var result = [];
      for (var key of Object.keys(this.filteredOrder)) {
        var obj = {
          fullName: this.filteredOrder[key][0].fardName,
          nationalCode: key,
        };
        for (var item of this.menuItems) {
          obj["item_" + item.id] = this.findMenuInOrders(item.id, key);
        }
        result.push(obj);
      }
      return result;
    },
  },

  created() {
    if (this.currentBranch) {
      this.GetBranchDeliveryPlace();

      this.tempAutoDelivery = this.autoDelivery;
    }
  },
  watch: {
    searchInput(value) {
      if (/\d{10}/.test(value)) {
        this.FindUser();
      } else {
        this.currentFard = "";
        this.selectedFardId = 0;
      }
    },
    showManualReserveDialog(val) {
      if (val) return; // you removed `return` here
      requestAnimationFrame(() => {
        this.ClearCode();
      });
    },
  },
  methods: {
    FindUser() {
      this.showManualReserveButton = false;
      return new Promise((resolve, reject) => {
        FindUserByCode(this.searchInput)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;
            this.selectedFardId = data.fardID;
            this.currentFard =
              data.fardID != 0
                ? data.name + " " + data.family
                : "موردی یافت نشد.";
            this.UserSelected = data.fardID != 0;
            if (this.UserSelected && this.BarcodeReaded) {
              this.UserSelected = false;

              if (this.filteredOrder[this.searchInput]) {
                if (this.tempAutoDelivery) {
                  this.deliverOrders(this.searchInput);
                }
              } else {
                // this.$store.commit(
                //   "SET_SNACKBAR_TEXT",
                //   "کاربر این وعده را رزرو نکرده است  ."
                // );
                this.showManualReserveButton = true;
                this.snackbar.text =
                  "<b>" +
                  this.currentFard +
                  "</b><br/>" +
                  "کاربر این وعده را رزرو نکرده است.";
                this.snackbar.show = true;
                this.snackbar.success = false;
                this.tempUser = {
                  id: this.selectedFardId,
                  name: this.currentFard,
                };
                this.ClearCode();
              }
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fromBarcode(event) {
      event.preventDefault();
      if (/\d{10}/.test(this.searchInput)) {
        this.BarcodeReaded = true;
        // this.showManualReserveButton = false;
        if (this.UserSelected) {
          this.BarcodeReaded = false;
          if (this.filteredOrder[this.searchInput]) {
            if (this.tempAutoDelivery) this.deliverOrders(this.searchInput);
          } else {
            // this.$store.commit(
            //   "SET_SNACKBAR_TEXT",
            //   "کاربر این وعده را رزرو نکرده است."
            // );
            this.showManualReserveButton = true;
            this.snackbar.text =
              "<b>" +
              this.currentFard +
              "</b><br/>" +
              "کاربر این وعده را رزرو نکرده است.";
            this.snackbar.show = true;
            this.snackbar.success = false;
            this.tempUser = {
              id: this.selectedFardId,
              name: this.currentFard,
            };
            this.ClearCode();
          }
        }
      }
    },
    setAutoDelivery() {
      setAutoDelivery(this.tempAutoDelivery);
    },
    GetBranchDeliveryPlace() {
      return new Promise((resolve, reject) => {
        GetBranchDeliveryPlace(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.places = response.data.items;
            this.deliveryPlaceId = this.places[0].id;
            this.GetBranchActiveMeals();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetBranchActiveMeals() {
      return new Promise((resolve, reject) => {
        GetBranchActiveMeals(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.meals = response.data.items;
            const currentTime = moment(new Date()).format("HH:mm:ss");
            let i = 0;
            for (; i < this.meals.length; i++) {
              if (this.meals[i].startTime > currentTime) {
                break;
              }
            }
            const index = Math.max(0, i - 1);
            this.selectedMeal = this.meals[index];
            this.tempSelectedMeal = this.meals[index];

            this.GetMealMenus(true);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetMealMenus(reload) {
      this.selectedMeal = this.tempSelectedMeal;
      this.selectedDate = this.tempSelectedDate;
      return new Promise((resolve, reject) => {
        GetMealMenus(
          this.selectedMeal.id,
          this.selectedDate,
          this.deliveryPlaceId
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.menuItems = response.data.items;
            if (reload) this.GetDeliveryPlaceOrders();
            this.showSelectMealDialog = false;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ClearCode() {
      this.currentFard = "";
      this.selectedFardId = 0;
      this.searchInput = "";
      this.UserSelected = false;
      this.BarcodeReaded = false;
      //this.showManualReserveButton = false;
      this.$refs.code.focus();
    },

    GetDeliveryPlaceOrders() {
      return new Promise((resolve, reject) => {
        GetDeliveryPlaceOrders(
          this.selectedMeal.id,
          this.selectedDate,
          this.deliveryPlaceId
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }

            this.orders = {};

            response.data.items.forEach((order) => {
              if (this.orders[order.nationalCode] == undefined) {
                this.orders[order.nationalCode] = [];
              }
              this.orders[order.nationalCode].push(order);
            });

            if (this.$refs.code) this.$refs.code.focus();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onClickDate() {
      this.$refs.fileInput1.click();
    },
    onChangeDate($event) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      this.tempSelectedDate = date;
    },
    findMenuInOrders(menuId, nationalCode) {
      let result = 0;
      for (let order of this.filteredOrder[nationalCode]) {
        if (order.menuID == menuId) {
          result += order.numberOrder;
          // break;
        }
      }
      return result;
    },
    deliverOrders(nationalCode) {
      console.log(this.filteredOrder[nationalCode]);
      Delivery(this.filteredOrder[nationalCode])
        .then((response) => {
          const data = response.data;
          const name = this.filteredOrder[nationalCode][0].fardName;
          this.snackbar.text = "<b>" + name + "</b><br/>" + data.message;
          this.snackbar.show = true;
          this.snackbar.success = data.data;

          new Audio(
            require(`@/assets/alerts/${data.data ? "success" : "error"}.mp3`)
          ).play();

          this.$store.commit("SET_API_RUNNING", false);
          this.showMenuDialog = false;
          if (data.data) {
            this.orders[nationalCode][0].deliveryDate = moment().format();
          }
          this.GetMealMenus(false);
          this.ClearCode();
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    saveAndDeliver() {
      var text = "";
      let filledMeal = [];
      for (let element of this.menuItems) {
        if (element.numberOfOrders && element.numberOfOrders > 0) {
          filledMeal.push(element);
        }
      }
      if (filledMeal.length == 0) {
        text = "حداقل یکی از عناوین منو بایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        // this.$store.commit("SET_API_RUNNING", true);
        let orders = [];
        this.menuItems.forEach((element) => {
          orders.push({
            Count: element.numberOfOrders,
            MenuPriceID: element.menuPrices[this.selectedMenuPrice - 1].id,
          });
        });
        SaveAndDeliver(this.tempUser.id, this.deliveryPlaceId, orders)
          .then((response) => {
            const data = response.data;
            this.showManualReserveButton = false;
            this.snackbar.text =
              "<b>" + this.tempUser.name + "</b><br/>" + data.message;
            this.snackbar.show = true;
            this.snackbar.success = data.data;
            new Audio(
              require(`@/assets/alerts/${data.data ? "success" : "error"}.mp3`)
            ).play();
            this.$store.commit("SET_API_RUNNING", false);
            this.showManualReserveDialog = false;
            this.GetMealMenus(true);
            this.tempUser = { id: 0, name: "" };
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
            this.ClearCode();
          });
      }
    },
    showManualReserveDialogAction() {
      this.snackbar.show = false;
      this.showManualReserveDialog = true;
      for (const menu of this.menuItems) {
        menu["numberOfOrders"] = 1;
      }
    },
    cancelMenu(menuid, foodName) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", menuid);
      const deliveryPlaceName = this.places.filter(
        (single) => single.id == this.deliveryPlaceId
      )[0].name;
      const message =
        "آیا مایل به لغو " + foodName + " در " + deliveryPlaceName + " هستید؟";
      this.$store.commit("SET_DIALOG_MESSAGE", message);
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    onCloseDialog(index) {
      if (index != -1) {
        CancelMenu(index, this.deliveryPlaceId)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetMealMenus(true);
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
<style scoped>
.v-data-table th {
  color: black !important;
}

.v-input--switch {
  width: 100%;
  margin-right: 0 !important;
}
.filterMarginButton {
  margin-right: 10px;
  width: unset !important;
}

.v-application--is-ltr .v-data-table__mobile-row__header {
  padding-right: 0px;
  max-width: 70%;
}

.circle {
  min-width: 32px;
  line-height: 32px;
  border-radius: 50%;
  text-align: center;
  font-size: 24px;
  border: 2px solid #666;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-table-row {
  display: flow-root;
  margin: 10px 0;
}
.v-data-table__mobile-row {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
</style>
<style></style>
